import Vue from 'vue'

const mutations = {

  SET_REQUESTS_FAILED_LIST (state, requests) {
    Vue.set(state, 'requests_failed_list', requests)
  },
  ADD_REQUEST_FAILED (state, request) {
    if (state.requests_failed_list.findIndex(req => req.id === request.id) === -1) {
      request.seen = false
      state.requests_failed_list.push(request)
    }
  },
  MARK_FAILED_AS_SEEN (state) {
    for (const req of state.requests_failed_list) {
      req.seen = true
    }
  }
}

export default mutations



//////////////////
// WEBPACK FOOTER
// ./state/request/request.mutations.js
// module id = null
// module chunks = 